import { createFileRoute } from '@tanstack/react-router';

import { RectificationsPage } from '@/features/quality/rectifications-page';

export const Route = createFileRoute('/_app/projects/$projectId/quality/rectifications')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <RectificationsPage projectId={projectId} />;
}
